/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useContent } from '../../context/ContentContext';
import QuoteModal from './QuoteModal';

const Products = () => {
  const { products, loading, fetchProducts } = useContent();
  const [selectedStory, setSelectedStory] = useState(null);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);

  const successStories = [
    {
      id: 1,
      title: 'From Struggle to Success: Mary\'s Farming Cooperative',
      category: 'Women Empowerment',
      image: '/assets/img/farmo/success-story-1.jpg',
      description: 'Mary lost her husband during the conflict, leaving her with five children to support. Through FARMO\'s training program, she learned climate-smart farming techniques and joined a local cooperative. Today, Mary leads a group of 30 women farmers who supply vegetables to the local market.',
      impact: 'Increased income by 300%, Employed 5 community members',
      location: 'Central Equatoria',
      date: '2024'
    },
    {
      id: 2,
      title: 'Youth Agri-preneurs Transforming Their Community',
      category: 'Youth Empowerment',
      image: '/assets/img/farmo/success-story-2.jpg',
      description: 'A group of 20 young people in Jonglei State received vocational training in aquaculture and vegetable farming. They established a youth-run farm that now produces fish and fresh vegetables, creating jobs for other young people in the area.',
      impact: 'Created 15 jobs, Produces 500kg of fish monthly',
      location: 'Jonglei State',
      date: '2024'
    },
    {
      id: 3,
      title: 'Peace Through Shared Agriculture',
      category: 'Peacebuilding',
      image: '/assets/img/farmo/success-story-3.jpg',
      description: 'In a community divided by ethnic tensions, FARMO facilitated dialogues and established a joint farming project. Former rivals now work side by side, sharing resources and profits, building trust through shared economic goals.',
      impact: 'Reduced conflict incidents by 80%, 200 families participating',
      location: 'Unity State',
      date: '2023'
    },
    {
      id: 4,
      title: 'Reforestation Brings Hope to Flood-Affected Area',
      category: 'Environment',
      image: '/assets/img/farmo/success-story-4.jpg',
      description: 'After devastating floods destroyed crops and homes, FARMO helped a community plant 10,000 trees along the riverbank. The trees now prevent erosion, provide shade for crops, and have become a source of fruit and firewood.',
      impact: '10,000+ trees planted, Flood damage reduced by 60%',
      location: 'Upper Nile',
      date: '2024'
    }
  ];

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return '/assets/img/farmo/placeholder.png';
    if (imageUrl.startsWith('/uploads')) {
      const apiUrl = 'https://farmo.zuddo.biz/api';
      const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
      return `${backendOrigin}${imageUrl}`;
    }
    return imageUrl;
  };

  const handleReadMore = (story) => {
    setSelectedStory(story);
    setIsQuoteModalOpen(true);
  };

  if (loading) {
    return (
      <div className="loading-section">
        <div className="spinner"></div>
        <p>Loading stories...</p>
      </div>
    );
  }

  return (
    <section className="success-stories section" id="success-stories">
      <div className="container">
        <div className="success-stories__header">
          <span className="section__subtitle">SUCCESS STORIES</span>
          <h2 className="section__title">Real Impact, <span className="highlight">Real Change</span></h2>
          <p className="success-stories__description">
            Hear from the farmers, women, and youth whose lives have been transformed through FARMO's programs.
          </p>
        </div>

        <div className="success-stories__grid">
          {successStories.map(story => (
            <div key={story.id} className="story-card">
              <div className="story-card__image">
                <img 
                  src={story.image} 
                  alt={story.title}
                  onError={(e) => {
                    e.target.src = '/assets/img/farmo/placeholder-story.jpg';
                  }}
                />
                <span className="story-category">{story.category}</span>
              </div>
              
              <div className="story-card__content">
                <div className="story-meta">
                  <span className="story-location">
                    <i className="ri-map-pin-line"></i> {story.location}
                  </span>
                  <span className="story-date">
                    <i className="ri-calendar-line"></i> {story.date}
                  </span>
                </div>
                <h3 className="story-title">{story.title}</h3>
                <p className="story-description">{story.description}</p>
                <div className="story-impact">
                  <i className="ri-flashlight-line"></i>
                  <span>{story.impact}</span>
                </div>
                <button 
                  className="btn-read-more"
                  onClick={() => handleReadMore(story)}
                >
                  Read Full Story
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="success-stories__cta">
          <div className="cta-banner">
            <h3>Share Your Story</h3>
            <p>Are you a beneficiary of FARMO's programs? We'd love to hear your journey.</p>
            <button className="button button--outline">Share Your Story</button>
          </div>
        </div>
      </div>

      <QuoteModal
        service={selectedStory}
        isOpen={isQuoteModalOpen}
        onClose={() => {
          setIsQuoteModalOpen(false);
          setSelectedStory(null);
        }}
      />
    </section>
  );
};

export default Products;